import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-message',
  templateUrl: './page-message.component.html',
  styleUrls: ['./page-message.component.css']
})
export class PageMessageComponent implements OnInit {

  constructor(
  ) {
  }

  ngOnInit() {
  }

}
